import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import SettingsMenuView from './SettingsMenuView';

interface SettingsMenuProps {}
const SettingsMenu: React.FC<SettingsMenuProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const goto = React.useCallback(
    (url: string) => {
      navigate(url);
    },
    [navigate]
  );

  const currentPath = location.pathname;

  return <SettingsMenuView goto={goto} currentPath={currentPath} />;
};

export default SettingsMenu;
